import { Component, Input, OnInit, inject } from '@angular/core';
import { ISockets } from '../notification-center.interface';
import { NotificationCenterService } from '../notification-center.service';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { NotificationItemComponent } from '../notification-item/notification-item.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-notification-center',
    templateUrl: './notification-center.component.html',
    styleUrls: ['./notification-center.component.scss'],
    imports: [
        NgClass,
        NotificationItemComponent,
        TranslatePipe
    ]
})
export class NotificationCenterComponent implements OnInit {
  notifyService = inject(NotificationCenterService);


  @Input('lists') lists: ISockets[];

  ngOnInit(): void {
  }

}
